import React, { useEffect, useRef, useState } from 'react';
import { Wind, Flame, Sun, Waves, Settings } from 'lucide-react';

const iconMap = {
  wind: Wind,
  flame: Flame,
  sun: Sun,
  waves: Waves,
  settings: Settings
};

export const Solutions = ({ data }) => {
  const [visibleCards, setVisibleCards] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          data.forEach((_, index) => {
            setTimeout(() => {
              setVisibleCards(prev => [...prev, index]);
            }, index * 150);
          });
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [data]);

  return (
    <section id="solutions" ref={sectionRef} className="solutions-section">
      <div className="container">
        <h2 className="section-title">Our Solutions</h2>
        <div className="solutions-grid">
          {data.map((solution, index) => {
            const Icon = iconMap[solution.icon];
            return (
              <div
                key={solution.id}
                className={`solution-card ${visibleCards.includes(index) ? 'visible' : ''}`}
              >
                <div className="solution-icon">
                  <Icon size={40} />
                </div>
                <h3 className="solution-title">{solution.title}</h3>
                <p className="solution-description">{solution.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};